import Layout from "@/components/Layout/Layout";
import ResourcesLayout from "./ResourcesLayout";

export default function Links({ section, data, close, white }) {
    const links = data?.[0]?.uri ? JSON.parse(data[0].uri) : [];
    const filteredLinks = links.filter(link => link.iri && link.title);

    return (
        <Layout section={section}>
            <ResourcesLayout data={data} close={close} white={white}>
                <ul className="area-card--links flow--l">
                    {filteredLinks.map(({iri, title}) => (
                        <li key={iri} className="link-block">
                            <h2 className="is-size-2 has-text-weight-semibold">{title}</h2>
                            <a href={iri} target="_blank"><p>{iri}</p></a>
                        </li>
                    ))}
                </ul>
            </ResourcesLayout>
        </Layout>
    )
}